import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import * as parentConstants from 'modules/notifications/NotificationsPage/constants';
import Page from 'modules/Page';
import { i18n } from 'i18n';
import * as localConstants from './constants';

const NewNotificationPage = lazyWithSuspense(() => import('./NewNotificationPage'));

const page: Page = {
  title: localConstants.TITLE,
  routeProps: {
    path: localConstants.ROUTE_PATH,
  },
  admin: true,
  component: makePage({
    WrappedPage: NewNotificationPage,
    titleFn: () => i18n._(localConstants.TITLE),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
  }),
};

export default page;
